export default function() {
  const widgetName = 'multiScheduleFeature';
  const widgetOpts = multiScheduleFeatureOpts;
  
  $(`#${widgetName}`).append('<div class="multiFeatureContent"></div>');

  $(`#${widgetName}`).MultiScheduleFeature({
      scriptPath: widgetOpts.scriptPath
      , currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID
      , detectIpad: IPADDETECTED
      , isResponsive: false
      // options
      , allEventsLink: true
      , allEventsLinkText: 'SEE ALL EVENTS'
      , hasImages: false
      , imageBackground: false
      , lazyLoadImages: true
      , buyNowButton: {visible: false, text: 'BUY NOW'}
      , moreButton: {visible: false, text: 'MORE'}
      , maxItemsVisible: 6
      , hasDescription: true
      , textContainer: true
      , link: 'all' // options are 'all', 'text', 'image', 'imageAndText', or ''
      , attributeOrder: {
        1: 'image',
        2: 'title',
        3: 'date',
        4: 'description',
        5: 'buttons'
      }
      , multiFeatureLoaded: function(data) {


        $('#multiScheduleFeature .all-events-btn').text('View Full Event Calendar');

        $('#multiScheduleFeature .featureItem').each(function () {
          var eventDate = $(this).find($('span.featureItemDate'));
          var datesMonth = eventDate.text().slice(0, 3);
          var datesDay = eventDate.text().slice(4, 7).replace(',', '');
          eventDate.text(datesMonth);
          eventDate.append("<span class='day'>" + datesDay + "</span>");
    
          const itemTitle = $(this).find('.featureItemTitle');
          eventDate.insertBefore(itemTitle);
    
          // Create a container div for title and description
          const titleAndDescriptionContainer = $('<div>').addClass('titleAndDescriptionContainer');
    
          // Move the title inside the container
          titleAndDescriptionContainer.append(itemTitle);
    
          // Find the description element and move it inside the container if it exists
          const itemDescription = $(this).find('.featureItemDescription');
          if (itemDescription.length > 0) {
            titleAndDescriptionContainer.append(itemDescription);
          }
    
          // Insert the new container after the event date
          titleAndDescriptionContainer.insertAfter(eventDate);
    
        });        
      }
  });
};


// helper functions

function setCharLimit(el, limit) {
  const text = el.text();
  return text.length > limit ? `${text.substring(0, limit)}...` : text;
}

function formatDate(el) {
  const datesMonth = el.text().slice(0,3);
  const datesDay = el.text().slice(4,7).replace(',','');
  el.html(`${datesMonth}<span>${datesDay}</span>`);
}